import { RootState } from 'types';

export const layoutSelector = (state: RootState) => state.layoutContainer;
export const lockStatusSelector = (state: RootState) => state.layoutContainer.LockStatusData;
